// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderConfirmationBillingInformationStyles } from "@steiner/Overrides/Widgets/OrderConfirmation/OrderConfirmationBillingInformation";
import { avoidBreakInsidePrintElement, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

orderConfirmationBillingInformationStyles.billingInformationGridContainer = {
    gap: 12,
};

orderConfirmationBillingInformationStyles.billingInformationTitle = {
    variant: "h4",
    as: "h3",
    css: css`
        margin-bottom: 0;
    `,
};

orderConfirmationBillingInformationStyles.billingInformationBillingAddressGridItem = {
    width: [12, 6, 6, 4, 4],
    css: css`
        flex-direction: column;
    `,
};

orderConfirmationBillingInformationStyles.billingAddressTitle = {
    variant: "h6",
    as: "h4",
};

orderConfirmationBillingInformationStyles.billingInformationCreditCardAddressGridItem = {
    width: [12, 6, 6, 4, 4],
    css: css`
        flex-direction: column;

        &&&& {
            ${xScreen("lte", "xs")} {
                margin-top: 12px;
            }
        }
    `,
};

orderConfirmationBillingInformationStyles.billingCreditCardAddressTitle = {
    variant: "h6",
    as: "h4",
};
orderConfirmationBillingInformationStyles.addressInfoDisplayWrapper = {
    css: css`
        display: block;
        ${avoidBreakInsidePrintElement}
    `,
};
